import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';


module.exports = {
    // eslint-disable-next-line max-params
    createFetchParams: (selectedMonth, pagination, search, sort, exclude, entities) => ({
        ...pagination,
        ...search,
        ...entities,
        ordering:       sort,
        exclude,
        selected_month: Math.floor(selectedMonth / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'cloudBillingRegions',
        endpoint:           endpoints.cloudBilling.regionsEndpoint,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
        transformResultsFn: item => ({
            ...item,
            total:         item.total_selected_month,
            totalPrevious: item.total_previous_month,
            count:         item.count,
            results:       item.results.map(region => ({
                shortCode:             region.code,
                id:                    region.id,
                name:                  region.name,
                spending:              region.spending_selected_month,
                previousSpending:      region.spending_previous_month,
                spendingSelectedMonth: region.spending_selected_month,
                spendingPreviousMonth: region.spending_previous_month,
                vendor:                {
                    code: region.vendor.code,
                    name: region.vendor.title
                }
            }))
        })
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/cloudBillingRegions.js